module.exports = __webpack_public_path__ + "static/media/video-user.4d86fa33.png";